export default __webpack_public_path__ + "static/media/P-036.862424d3.png";